import { useQuery, keepPreviousData } from '@tanstack/react-query'
import type { ServicesResponse } from 'shared'
import { apiGet } from '../lib/api'
import { useDebouncedValue } from './useDebouncedValue'

type UseServicesParams = {
  q?: string
  category?: string
  page?: number
  limit?: number
}

export function useServices({ q = '', category = 'All', page = 1, limit }: UseServicesParams) {
  const debouncedQ = useDebouncedValue(q.trim(), 300)

  const params = new URLSearchParams()
  if (debouncedQ) params.set('q', debouncedQ)
  if (category && category !== 'All') params.set('category', category)
  params.set('page', String(page))
  if (limit != null) params.set('limit', String(limit))

  return useQuery({
    queryKey: ['services', { q: debouncedQ, category, page, limit }],
    queryFn: ({ signal }) => apiGet<ServicesResponse>('/services?' + params.toString(), signal),
    placeholderData: keepPreviousData,
  })
}
